import { motion, AnimatePresence } from "framer-motion";
import { useMicPermissionStore } from "@/features/tutor/store/useMicPermissionStore";

interface MicToastProps {
  onRetry?: () => void;
}

const MicToast = ({ onRetry }: MicToastProps) => {
  const { micUnavailable } = useMicPermissionStore();

  return (
    <AnimatePresence>
      {micUnavailable && (
        <motion.div
          key="mic-disabled"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          className="flex justify-center pointer-events-none w-full"
        >
          <div
            className={`flex items-center gap-3 px-5 py-[15px] bg-[#FFF0D1] rounded-[10px] pointer-events-auto ${onRetry ? "cursor-pointer" : ""}`}
            onClick={onRetry}
          >
            <svg
              width="18"
              height="22"
              viewBox="0 0 18 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.9369 14.0711C14.8141 14.0713 14.6927 14.0444 14.5809 13.9922C14.4772 13.9444 14.3838 13.8761 14.3059 13.7912C14.228 13.7064 14.1673 13.6067 14.127 13.4978C14.0868 13.389 14.068 13.2731 14.0715 13.1567C14.0751 13.0404 14.101 12.9259 14.1479 12.8199C14.5029 12.0179 14.6857 11.1473 14.684 10.2669C14.684 10.0319 14.7753 9.80647 14.9377 9.64028C15.1001 9.4741 15.3204 9.38074 15.5501 9.38074C15.7799 9.38074 16.0002 9.4741 16.1626 9.64028C16.325 9.80647 16.4163 10.0319 16.4163 10.2669C16.4169 11.3979 16.1806 12.5159 15.7234 13.5456C15.6556 13.7013 15.5453 13.8337 15.4058 13.9269C15.2663 14.0201 15.1035 14.0702 14.9369 14.0711Z"
                fill="#FF8400"
              />
              <path
                d="M4.69037 3.76904C4.69037 2.76943 5.12276 1.81076 5.89242 1.10393C6.66208 0.397094 7.70597 0 8.79444 0C9.8829 0 10.9268 0.397094 11.6965 1.10393C12.4661 1.81076 12.8985 2.76943 12.8985 3.76904V9.79951C12.8985 9.99943 12.812 10.1912 12.6581 10.3325C12.5042 10.4739 12.2954 10.5533 12.0777 10.5533L4.69037 3.76904Z"
                fill="#FF8400"
              />
              <path
                d="M17.3642 18.0261L1.35643 1.40587C1.20547 1.25449 1.00329 1.17073 0.793433 1.17262C0.583574 1.17452 0.382827 1.26191 0.234428 1.41599C0.08603 1.57007 0.00185388 1.77849 3.02566e-05 1.99638C-0.00179336 2.21427 0.0788816 2.42419 0.224679 2.58092L4.79249 7.32349V10.3035C4.79252 11.0542 4.98841 11.7908 5.35935 12.4351C5.73028 13.0794 6.2624 13.6074 6.89917 13.9629C7.53595 14.3184 8.25358 14.4881 8.97583 14.4541C9.69808 14.4201 10.398 14.1836 11.0011 13.7696L12.1457 14.958C11.3139 15.606 10.3247 16.0006 9.28894 16.0974C8.25323 16.1942 7.21202 15.9894 6.28215 15.5061C5.35229 15.0227 4.57055 14.2798 4.02466 13.3609C3.47878 12.4419 3.19034 11.3832 3.19172 10.3035C3.19172 10.0831 3.10739 9.87173 2.95729 9.71589C2.80719 9.56004 2.60361 9.47249 2.39133 9.47249C2.17905 9.47249 1.97547 9.56004 1.82537 9.71589C1.67527 9.87173 1.59094 10.0831 1.59094 10.3035C1.59334 12.1422 2.2473 13.9157 3.42817 15.286C4.60905 16.6562 6.23426 17.5275 7.99405 17.7336V19.4446H5.59288C5.38061 19.4446 5.17702 19.5322 5.02692 19.688C4.87682 19.8439 4.79249 20.0552 4.79249 20.2756C4.79249 20.496 4.87682 20.7074 5.02692 20.8632C5.17702 21.0191 5.38061 21.1066 5.59288 21.1066H11.996C12.2083 21.1066 12.4118 21.0191 12.5619 20.8632C12.712 20.7074 12.7964 20.496 12.7964 20.2756C12.7964 20.0552 12.712 19.8439 12.5619 19.688C12.4118 19.5322 12.2083 19.4446 11.996 19.4446H9.59482V17.7336C10.9468 17.5803 12.2284 17.029 13.2886 16.1447L16.2324 19.2011C16.3834 19.3525 16.5856 19.4363 16.7954 19.4344C17.0053 19.4325 17.206 19.3451 17.3544 19.191C17.5028 19.0369 17.587 18.8285 17.5888 18.6106C17.5907 18.3927 17.51 18.1828 17.3642 18.0261Z"
                fill="#FF8400"
              />
            </svg>
            <span className="font-nunito text-base font-semibold text-black">
              Mic disabled, EverTutor can't hear you
            </span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MicToast;
